import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/user/wxuserdetail/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/user/wxuserdetail/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/user/wxuserdetail/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/user/wxuserdetail/submit',
    method: 'post',
    data: row
  })
}

